import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
	ApplicationDevelopmentStatusStyled,
	ApplicationSuccessStatusStyled,
	ApplicationWarningStatusStyled,
} from './ApplicationStatus.styles';

interface Props {
	status: string | undefined;
	tariffName?: string;
}

export const ApplicationStatus: FC<Props> = ({ status, tariffName }) => {
	const { t } = useTranslation();
	switch (status) {
		case `trial`:
			return <ApplicationWarningStatusStyled>Триал</ApplicationWarningStatusStyled>;
		case `active-subscription`:
			return <ApplicationSuccessStatusStyled>Подписка {tariffName ?? `активна`}</ApplicationSuccessStatusStyled>;
		case `beta`:
			return (
				<ApplicationDevelopmentStatusStyled>{t(`Marketplace_Beta_Version`)}</ApplicationDevelopmentStatusStyled>
			);
		case `development`:
			return (
				<ApplicationDevelopmentStatusStyled>
					{t(`Marketplace_In_Development`)}
				</ApplicationDevelopmentStatusStyled>
			);
		case `updated`:
			return <ApplicationSuccessStatusStyled>{t(`Marketplace_Update`)}</ApplicationSuccessStatusStyled>;
		case `new`:
			return <ApplicationSuccessStatusStyled>{t(`Marketplace_New`)}</ApplicationSuccessStatusStyled>;
		default:
			return null;
	}
};
